import { SetterOrUpdater } from "recoil";
import { datadogRum } from "@datadog/browser-rum";
import { NewRequisitionFormEdit } from "../../recoil/types";
import { getTrimester, parseYmdAtNoonUtc } from "../../utils/helpers";

export const onChangeCarrierScreenZ84 = (
  e: React.ChangeEvent<HTMLInputElement>,
  newRequisition: NewRequisitionFormEdit,
  setNewRequisition: SetterOrUpdater<NewRequisitionFormEdit>,
): void => {
  const carrierScreenCodes = { Z8481: e.target.checked };
  setNewRequisition({
    ...newRequisition,
    requisitionForm: {
      ...newRequisition.requisitionForm,
      ...carrierScreenCodes,
    },
  });
};
export const onChangeCarrierScreenZ31 = (
  e: React.ChangeEvent<HTMLInputElement>,
  newRequisition: NewRequisitionFormEdit,
  setNewRequisition: SetterOrUpdater<NewRequisitionFormEdit>,
): void => {
  const carrierScreenCodes = { Z31430: false, Z31440: false };
  if (e.target.checked) {
    if (newRequisition.requisitionForm.sex === "Female") {
      carrierScreenCodes.Z31430 = true;
    } else {
      carrierScreenCodes.Z31440 = true; // for males
    }
  }
  setNewRequisition({
    ...newRequisition,
    requisitionForm: {
      ...newRequisition.requisitionForm,
      ...carrierScreenCodes,
    },
  });
};
export const onChangeCarrierScreenZ810 = (
  e: React.ChangeEvent<HTMLInputElement>,
  newRequisition: NewRequisitionFormEdit,
  setNewRequisition: SetterOrUpdater<NewRequisitionFormEdit>,
): void => {
  const carrierScreenCodes = { Z810: e.target.checked };
  setNewRequisition({
    ...newRequisition,
    requisitionForm: {
      ...newRequisition.requisitionForm,
      ...carrierScreenCodes,
    },
  });
};
export const onChangeAneuploidyScreenO0951 = (
  e: React.ChangeEvent<HTMLInputElement>,
  newRequisition: NewRequisitionFormEdit,
  setNewRequisition: SetterOrUpdater<NewRequisitionFormEdit>,
): void => {
  const aneuploidyCodes = { O09511: false, O09512: false, O09513: false };

  if (e.target.checked) {
    const trimester = getTrimester(
      parseYmdAtNoonUtc(newRequisition.requisitionForm.estimatedDueDate),
    );
    if (trimester === 1) {
      aneuploidyCodes.O09511 = true;
    } else if (trimester === 2) {
      aneuploidyCodes.O09512 = true;
    } else if (trimester === 3) {
      aneuploidyCodes.O09512 = true;
    } else {
      datadogRum.addError("Unknown trimester onChangeAneuploidyScreenO0951");
    }
  }
  setNewRequisition({
    ...newRequisition,
    requisitionForm: {
      ...newRequisition.requisitionForm,
      ...aneuploidyCodes,
    },
  });
};
export const onChangeAneuploidyScreenO0952 = (
  e: React.ChangeEvent<HTMLInputElement>,
  newRequisition: NewRequisitionFormEdit,
  setNewRequisition: SetterOrUpdater<NewRequisitionFormEdit>,
): void => {
  const aneuploidyCodes = { O09521: false, O09522: false, O09523: false };

  if (e.target.checked) {
    const trimester = getTrimester(
      parseYmdAtNoonUtc(newRequisition.requisitionForm.estimatedDueDate),
    );
    if (trimester === 1) {
      aneuploidyCodes.O09521 = true;
    } else if (trimester === 2) {
      aneuploidyCodes.O09522 = true;
    } else if (trimester === 3) {
      aneuploidyCodes.O09522 = true;
    } else {
      datadogRum.addError("Unknown trimester onChangeAneuploidyScreenO0952");
    }
  }
  setNewRequisition({
    ...newRequisition,
    requisitionForm: {
      ...newRequisition.requisitionForm,
      ...aneuploidyCodes,
    },
  });
};

export const onChangeAneuploidyScreenO098 = (
  e: React.ChangeEvent<HTMLInputElement>,
  newRequisition: NewRequisitionFormEdit,
  setNewRequisition: SetterOrUpdater<NewRequisitionFormEdit>,
): void => {
  const aneuploidyCodes = { O09891: false, O09892: false, O09893: false };

  if (e.target.checked) {
    const trimester = getTrimester(
      parseYmdAtNoonUtc(newRequisition.requisitionForm.estimatedDueDate),
    );
    if (trimester === 1) {
      aneuploidyCodes.O09891 = true;
    } else if (trimester === 2) {
      aneuploidyCodes.O09892 = true;
    } else if (trimester === 3) {
      aneuploidyCodes.O09893 = true;
    } else {
      datadogRum.addError("Unknown trimester onChangeAneuploidyScreenO098");
    }
  }
  setNewRequisition({
    ...newRequisition,
    requisitionForm: {
      ...newRequisition.requisitionForm,
      ...aneuploidyCodes,
    },
  });
};
export const onChangeCarrierScreenZ348 = (
  e: React.ChangeEvent<HTMLInputElement>,
  newRequisition: NewRequisitionFormEdit,
  setNewRequisition: SetterOrUpdater<NewRequisitionFormEdit>,
): void => {
  const carrierCodes = {
    Z3481_carrier: false,
    Z3482_carrier: false,
    Z3483_carrier: false,
  };

  if (e.target.checked) {
    const trimester = getTrimester(
      parseYmdAtNoonUtc(newRequisition.requisitionForm.estimatedDueDate),
    );
    if (trimester === 1) {
      carrierCodes.Z3481_carrier = true;
    } else if (trimester === 2) {
      carrierCodes.Z3482_carrier = true;
    } else if (trimester === 3) {
      carrierCodes.Z3483_carrier = true;
    } else {
      datadogRum.addError("Unknown trimester onChangeCarrierScreenZ348");
    }
  }
  setNewRequisition({
    ...newRequisition,
    requisitionForm: {
      ...newRequisition.requisitionForm,
      ...carrierCodes,
    },
  });
};
export const onChangeAneuploidyScreenZ348 = (
  e: React.ChangeEvent<HTMLInputElement>,
  newRequisition: NewRequisitionFormEdit,
  setNewRequisition: SetterOrUpdater<NewRequisitionFormEdit>,
): void => {
  const aneuploidyCodes = {
    Z3481_aneuploidy: false,
    Z3482_aneuploidy: false,
    Z3483_aneuploidy: false,
  };

  if (e.target.checked) {
    const trimester = getTrimester(
      parseYmdAtNoonUtc(newRequisition.requisitionForm.estimatedDueDate),
    );
    if (trimester === 1) {
      aneuploidyCodes.Z3481_aneuploidy = true;
    } else if (trimester === 2) {
      aneuploidyCodes.Z3482_aneuploidy = true;
    } else if (trimester === 3) {
      aneuploidyCodes.Z3483_aneuploidy = true;
    } else {
      datadogRum.addError("Unknown trimester onChangeAneuploidyScreenZ348");
    }
  }
  setNewRequisition({
    ...newRequisition,
    requisitionForm: {
      ...newRequisition.requisitionForm,
      ...aneuploidyCodes,
    },
  });
};
export const onChangeAneuploidyScreenZ340 = (
  e: React.ChangeEvent<HTMLInputElement>,
  newRequisition: NewRequisitionFormEdit,
  setNewRequisition: SetterOrUpdater<NewRequisitionFormEdit>,
): void => {
  const aneuploidyCodes = { Z3401: false, Z3402: false, Z3403: false };

  if (e.target.checked) {
    const trimester = getTrimester(
      parseYmdAtNoonUtc(newRequisition.requisitionForm.estimatedDueDate),
    );
    if (trimester === 1) {
      aneuploidyCodes.Z3401 = true;
    } else if (trimester === 2) {
      aneuploidyCodes.Z3402 = true;
    } else if (trimester === 3) {
      aneuploidyCodes.Z3403 = true;
    } else {
      datadogRum.addError("Unknown trimester onChangeAneuploidyScreenZ340");
    }
  }
  setNewRequisition({
    ...newRequisition,
    requisitionForm: {
      ...newRequisition.requisitionForm,
      ...aneuploidyCodes,
    },
  });
};
export const onChangeRhDScreenO036 = (
  e: React.ChangeEvent<HTMLInputElement>,
  newRequisition: NewRequisitionFormEdit,
  setNewRequisition: SetterOrUpdater<NewRequisitionFormEdit>,
): void => {
  const aneuploidyCodes = { O360110: false, O360120: false, O360130: false };

  if (e.target.checked) {
    const trimester = getTrimester(
      parseYmdAtNoonUtc(newRequisition.requisitionForm.estimatedDueDate),
    );
    if (trimester === 1) {
      aneuploidyCodes.O360110 = true;
    } else if (trimester === 2) {
      aneuploidyCodes.O360120 = true;
    } else if (trimester === 3) {
      aneuploidyCodes.O360130 = true;
    } else {
      datadogRum.addError("Unknown trimester onChangeRhDScreenO036");
    }
  }
  setNewRequisition({
    ...newRequisition,
    requisitionForm: {
      ...newRequisition.requisitionForm,
      ...aneuploidyCodes,
    },
  });
};

export const onChangeRhDScreenZ31 = (
  e: React.ChangeEvent<HTMLInputElement>,
  newRequisition: NewRequisitionFormEdit,
  setNewRequisition: SetterOrUpdater<NewRequisitionFormEdit>,
): void => {
  const carrierScreenCodes = { Z3182: e.target.checked };
  setNewRequisition({
    ...newRequisition,
    requisitionForm: {
      ...newRequisition.requisitionForm,
      ...carrierScreenCodes,
    },
  });
};

export const onCarrierScreenO285 = (
  e: React.ChangeEvent<HTMLInputElement>,
  newRequisition: NewRequisitionFormEdit,
  setNewRequisition: SetterOrUpdater<NewRequisitionFormEdit>,
): void => {
  const carrierScreenCodes = { O285_carrier: e.target.checked };
  setNewRequisition({
    ...newRequisition,
    requisitionForm: {
      ...newRequisition.requisitionForm,
      ...carrierScreenCodes,
    },
  });
};

export const onAneuploidyScreenO285 = (
  e: React.ChangeEvent<HTMLInputElement>,
  newRequisition: NewRequisitionFormEdit,
  setNewRequisition: SetterOrUpdater<NewRequisitionFormEdit>,
): void => {
  const aneuploidyScreenCodes = { O285_aneuploidy: e.target.checked };
  setNewRequisition({
    ...newRequisition,
    requisitionForm: {
      ...newRequisition.requisitionForm,
      ...aneuploidyScreenCodes,
    },
  });
};

export const onChangeRhDScreenO283 = (
  e: React.ChangeEvent<HTMLInputElement>,
  newRequisition: NewRequisitionFormEdit,
  setNewRequisition: SetterOrUpdater<NewRequisitionFormEdit>,
): void => {
  const carrierScreenCodes = { O283: e.target.checked };
  setNewRequisition({
    ...newRequisition,
    requisitionForm: {
      ...newRequisition.requisitionForm,
      ...carrierScreenCodes,
    },
  });
};

export const onChangeFetalAntigenO36 = (
  e: React.ChangeEvent<HTMLInputElement>,
  newRequisition: NewRequisitionFormEdit,
  setNewRequisition: SetterOrUpdater<NewRequisitionFormEdit>,
): void => {
  const aneuploidyCodes = { O361910: false, O361920: false, O361930: false };

  if (e.target.checked) {
    const trimester = getTrimester(
      parseYmdAtNoonUtc(newRequisition.requisitionForm.estimatedDueDate),
    );
    if (trimester === 1) {
      aneuploidyCodes.O361910 = true;
    } else if (trimester === 2) {
      aneuploidyCodes.O361920 = true;
    } else if (trimester === 3) {
      aneuploidyCodes.O361930 = true;
    } else {
      datadogRum.addError("Unknown trimester onChangeFetalAntigenO36");
    }
  }
  setNewRequisition({
    ...newRequisition,
    requisitionForm: {
      ...newRequisition.requisitionForm,
      ...aneuploidyCodes,
    },
  });
};
